import { useEffect, useRef, useState } from "react";
import { useInView, useReducedMotion } from "framer-motion";

const CHARS = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789#/";

export const Scramble = ({ text, className = "", speed = 42, frames = 18 }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-40px" });
  const reduce = useReducedMotion();
  const [out, setOut] = useState(text);

  useEffect(() => {
    if (!inView) return;
    if (reduce) {
      setOut(text);
      return;
    }
    let frame = 0;
    const id = setInterval(() => {
      frame++;
      const settled = Math.floor((frame / frames) * text.length);
      setOut(
        text
          .split("")
          .map((c, i) => {
            if (c === " " || c === "&" || c === "'" || c === "." || c === "," || c === "?" || c === "!") return c;
            return i < settled ? c : CHARS[Math.floor(Math.random() * CHARS.length)];
          })
          .join("")
      );
      if (frame >= frames) {
        setOut(text);
        clearInterval(id);
      }
    }, speed);
    return () => clearInterval(id);
  }, [inView, text, reduce, speed, frames]);

  return (
    <span ref={ref} className={className} aria-label={text} role="text">
      <span aria-hidden="true">{out}</span>
    </span>
  );
};
